export default {
      id: "import_mm_template-usage",
      viewBox: "0 0 17.64 17.5",
      url: __webpack_public_path__ + "img/icons.ea6ea76b.svg#import_mm_template",
      toString: function () {
        return this.url;
      }
    }